import { axiosPrivate } from '../../api/connector'

export function runOptimize(projectId: string) {
    return axiosPrivate.post(`/v1/optimization/`, { project: projectId })
}
